<template>
    <div v-if="dataResponse" class="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
        <div class="bg-blue-700 overflow-hidden shadow rounded-lg">
            <loading :status="dataResponse == null"/>
            <div class="px-4 py-5 sm:p-6">
                <dt class="text-sm font-medium text-white truncate">
                    {{ $t('Open tickets') }}
                </dt>
                <dd class="mt-1 text-3xl font-semibold text-yellow-100">
                    {{ dataResponse.open_tickets ? dataResponse.open_tickets : 0 }}
                </dd>
            </div>
        </div>
        <div class="bg-yellow-600 overflow-hidden shadow rounded-lg">
            <loading :status="dataResponse == null"/>
            <div class="px-4 py-5 sm:p-6">
                <dt class="text-sm font-medium text-white truncate">
                    {{ $t('Pending tickets') }}
                </dt>
                <dd class="mt-1 text-3xl font-semibold text-yellow-100">
                    {{ dataResponse.pending_tickets ? dataResponse.pending_tickets : 0 }}
                </dd>
            </div>
        </div>
        <div class="bg-green-600 overflow-hidden shadow rounded-lg">
            <loading :status="dataResponse == null"/>
            <div class="px-4 py-5 sm:p-6">
                <dt class="text-sm font-medium text-white truncate">
                    {{ $t('Solved tickets') }}
                </dt>
                <dd class="mt-1 text-3xl font-semibold text-yellow-100">
                    {{ dataResponse.solved_tickets ? dataResponse.solved_tickets : 0 }}
                </dd>
            </div>
        </div>
        <div class="bg-purple-600 overflow-hidden shadow rounded-lg">
            <loading :status="dataResponse == null"/>
            <div class="px-4 py-5 sm:p-6">
                <dt class="text-sm font-medium text-white truncate">
                    {{ $t('Without assign agent') }}
                </dt>
                <dd class="mt-1 text-3xl font-semibold text-yellow-100">
                    {{ dataResponse.without_agent ? dataResponse.without_agent : 0 }}
                </dd>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TicketSummary",
    props: ['dataResponse'],
    data() {
        return {
          
        }
    },
    mounted() {
        
    },
    methods: {
       
    },

    
}
</script>

